import React from "react"
import { useItemWrapStyles } from "./style"

interface ComponentProps {
    children: React.ReactNode,
}
export default (props: ComponentProps) => {
    const { children } = props
    const classes = useItemWrapStyles()
    return (
        <div className={classes.root}>{ children }</div>
    )
}

